/**
 * 主模块
 * @author yuxin.zhang
 * @Date 2017-05-09
 */

import React from 'react';
import Cookies from 'js-cookie';

import RootContext from '_common/container/RootContext';
import ShowKey from '_common/container/showKey/ShowKey';
import { messenger } from '_common/utils/Messenger';

import { GuideBox } from '../components/GuideBox';

import TipsDialog from './TipsDialog';

export default class App extends RootContext {
  constructor(props, context) {
    super(props, context);

    this.state = {
      langClass: '',
      showKey: false,
    };
  }

  UNSAFE_componentWillMount() {
    this.setState({ langClass: Cookies.get('locale').toLowerCase() });
    window.showKey = this.state.showKey;
    messenger.onMessage('showKey', () => {
      window.showKey = !this.state.showKey;
      this.setState(
        {
          showKey: !this.state.showKey,
        },
        () => {
          this.render();
        }
      );
    });
  }

  render() {
    const { langClass } = this.state;
    return (
      <>
        <div className={`body-wrap account-wrap ${langClass}`}>
          {this.props.children}
        </div>
        <GuideBox />
        <TipsDialog />
        {localStorage.getItem('showKey') === '777' && <ShowKey />}
      </>
    );
  }
}
